/** Synced help assets (build artifact) — distinct from SPA route /help */
export const HELP_CONTENT_BASE = '/help-content';

const MANIFEST_URL = `${process.env.PUBLIC_URL || ''}${HELP_CONTENT_BASE}/help-manifest.json`;

let manifestCache = null;

/**
 * @returns {Promise<object>}
 */
export async function fetchHelpManifest() {
  if (manifestCache) return manifestCache;
  const res = await fetch(MANIFEST_URL, { cache: 'no-cache' });
  if (!res.ok) {
    throw new Error(`Help manifest not found (${res.status}). Run npm start to sync docs.`);
  }
  manifestCache = await res.json();
  return manifestCache;
}

/**
 * @param {string} relativePath - e.g. workflows/complaint-management.md
 * @returns {Promise<string>}
 */
export async function fetchHelpArticleMarkdown(relativePath) {
  const base = `${process.env.PUBLIC_URL || ''}${HELP_CONTENT_BASE}/`;
  const url = `${base}${relativePath}`;
  const res = await fetch(url, { cache: 'no-cache' });
  if (!res.ok) {
    throw new Error(`Help article not found (${res.status}): ${relativePath}`);
  }
  return res.text();
}

/** Clear cached manifest (tests / hot reload). */
export function clearHelpManifestCache() {
  manifestCache = null;
}

/**
 * Resolve synced help markdown image paths to public help-content URLs.
 * @param {string|null|undefined} src
 */
export function resolveHelpImageSrc(src) {
  if (!src) return src;
  if (/^https?:\/\//i.test(src) || src.startsWith('data:')) return src;

  const publicUrl = process.env.PUBLIC_URL || '';
  const contentPrefix = `${HELP_CONTENT_BASE}/`;
  if (src.startsWith(contentPrefix)) {
    return `${publicUrl}${src}`;
  }
  if (src.startsWith('/')) {
    return `${publicUrl}${src}`;
  }

  const normalized = src.replace(/^(\.\.\/)+/, '');
  return `${publicUrl}${HELP_CONTENT_BASE}/${normalized}`;
}
